import DirectoryProfileSecondaryContactInfo from './DirectoryProfileSecondaryContactInfo';

export default DirectoryProfileSecondaryContactInfo;
